import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Checkbox } from 'antd';
import DetailTable from './DetailTable';
import validate from './validate';
const {
  checkLen,
  checkTable,
} = validate;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form-step',
  }
  render() {
    const {
      prefixCls, form, formRequiredClass,
    } = this.props;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const { getFieldValue, getFieldProps, isFieldValidating, getFieldError } = form;
    return (
      <div className={`${prefixCls}`}>
        <FormItem
          label="设备支持："
          {...formItemLayout}
          className={formRequiredClass}
        >
          <CheckboxGroup
            {...getFieldProps('s_apptype',
              {
                initialValue: ['PC'],
                rules: [{ validator: checkLen }]
              })}
            options={['PC', 'MOBILE']}
          />
        </FormItem>
        <FormItem
          label="PC页面："
          {...formItemLayout}
          help={isFieldValidating('page') ? '校验中...' : (getFieldError('page') || []).join(', ')}>
          <DetailTable className={formRequiredClass} {
            ...getFieldProps("page",
              { rules: getFieldValue('s_apptype').indexOf("PC") >= 0 ? [{ required: true, validator: checkTable }] : [{ validator: (rule, value, callback) => { callback(); } }] }
            )
          } showData={getFieldValue('s_apptype').indexOf("PC") >= 0}
            onChange={(value) => {
              form.setFieldsValue({
                page: value,
              });
            }}
            appType="PC"
          />
        </FormItem>
        <FormItem
          label="MOILE页面："
          {...formItemLayout}
          help={getFieldValue('s_apptype') && getFieldValue('s_apptype').indexOf("MOBILE") >= 0 && isFieldValidating('pageMobile') ? '校验中...' : (getFieldError('pageMobile') || []).join(', ')}>
          <DetailTable className={formRequiredClass} {
            ...getFieldProps("pageMobile",
              { rules: getFieldValue('s_apptype').indexOf("MOBILE") >= 0 ? [{ required: true, validator: checkTable }] : [{ validator: (rule, value, callback) => { callback(); } }] }
            )
          } showData={getFieldValue('s_apptype').indexOf("MOBILE") >= 0}
            onChange={(value) => {
              form.setFieldsValue({
                pageMobile: value,
              });
            }}
            appType="MOBILE"
          />
        </FormItem>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form_step_0.js